'use client'
import React from 'react';
import {InputText, InputCounter, InputCheckbox, Tooltip, TimeInput, AddListIng, InputSelectEn, InputRadio} from '../../atoms'
import './Forms.css'  
import { Select, SelectEn} from '..'
import {Loader, ModalInfo} from '../../organisms'
import {timeInputs, complex, process, group, tool, hint, recipeErrors} from '../../../constants/constants' 
import {useDispatch, useSelector} from 'react-redux'
import {useFormValidation} from '../../../utils/Validator.js'
import {AutoComplete, useFormErrors, groupedIngredient} from '../../../utils/utils.js' 
import { useRecipeTime } from '../../../hooks/useRecipeTime';
import { IngredientsForm } from './IngredientsForm';
import { useIngredientsForm } from './useIngredientsForm';
import { useSaveRecipe, useIngredients  } from '../../../hooks/useRecipes';
import { useLibrary } from '../../../hooks/useStaticData';
import {  acceptRecipeUser} from '../../../store/api.js'

export const FormAddRecipe = (props) => {
  //const { lib, statusLib } = useSelector(state => state.lib)   
  const { statusRecipe, errorRecipe } = useSelector(state => state.recipe)  
  //const {ingredients, status} = useSelector(state => state.ingredients) 
  const [ingredientsData, setIngredientsData] = React.useState([])    
  const { currentUser, statusUser } = useSelector(state => state.currentUser)
  const [type, setType] = React.useState([]); 
  const [tools, setTools] = React.useState( []); 
  const [kitchenware, setКitchenware] = React.useState([]);  
  const {error, validate, setError} = useFormErrors()
  const dispatch = useDispatch()
  const editCard = props.card 
 const [recipeData, setRecipeData] = React.useState({
    name: editCard?.name || '',
    // ... другие поля
    ingredients: editCard?.ingredients || []
  });
 console.log(editCard?.ingredients, recipeData.ingredients)
   const options = [
    { value: 'private', label: 'Сделать приватным' },
    { value: 'active', label: 'Сделать активным' },  
  ];
 // 🔥 Хук для сохранения
  const { mutate: saveRecipe, isPending, isSuccess } = useSaveRecipe();
  const { data: ingredients, isLoading, } = useIngredients(); 
 const { data: lib, isLoading: statusLib, isSuccess: isSuccessLib} = useLibrary();
  
  const buttonTitle = editCard === undefined ? 'Добавить рецепт' : 'Редактировать рецепт' 
  let saves = JSON.parse(localStorage.getItem('saves')); // Соранение рецепта в браузере
  const [description, setDescription] = React.useState([{ step: 1, image: '', text: '' }]) 
  
  const {
    recipeTimes,
    timeUnits,
    handleTimeChange,
    handleUnitChange,
    getActiveTimesForServer,
    isValid: isTimeValid
  } = useRecipeTime(editCard?.times);
   console.log()
  const { 
    values, 
    handleChange,
    setValues,
    resetForm,
    nameError, 
    setNameError,
    setCategoryError,
    сategoryError,
    complexError,
    setComplexError,
    imageError, 
    setImageError
  } = useFormValidation({
    name: '',
    category: '',
    servings: 1,
    complexity: '',
    feast: false,
    daily: false,
    times: [],
    image: [],
    source: '',
    advice: '',
    metaDesc: '',
    status: false
  });
  
 /*const { 
    getIngredientsForServer
  } = useIngredientsForm(
    editCard?.ingredients || [],
    ingredients,
    (newIngredients) => {
      // Обновляем recipeData при изменении ингредиентов
      setRecipeData(prev => ({ ...prev, ingredients: newIngredients }));
    }
  );*/

  const typeError = type.length === 0
  const timeError = recipeTimes.basic  > 0
  const timeMarkError = recipeTimes.basic === 0
  const formError = !values.name || !values.category || !values.complexity || values.image.length === 0 || recipeData.ingredients.length === 0 || description[0].text === '' || typeError || !timeError || timeMarkError
  const submitDisabled = error.ingredient || error.totalWeight || nameError || formError
  const timeForServer = getActiveTimesForServer();
  //const serverIngredients = getIngredientsForServer();
   
 
  function FormError() {
    const newErrors = {};
    if(!values.name) {
      setNameError('Поле не может быть пустым')
    } 
    if(!values.category  ) { 
      setCategoryError('Выберите категорию')
    }
    if(!values.complexity  ) { 
      setComplexError('Выберите сложность блюда')
    }
    if(values.image.length === 0 ) {  
      setImageError('Загрузите фото готового блюда')
    }
    if (recipeData.ingredients.length === 0) {
      newErrors.ingredients = 'Выберите хотя бы один ингредиент';
      newErrors.weight = 'Добавьте количество';
      newErrors.note = 'Выберите способ обработки';
    }
    if(description[0].text === '' ) { 
      newErrors.step1 = 'Заполните хотя бы 1 шаг приготовления';
    } 
  // Проверка времени
  if (!timeError) {
      newErrors.basic = 'Укажите время';
  } else if(timeMarkError) { 
    newErrors.basic = 'Это поле обязательное для заполнения';
 } 
  // Проверка типа питания
  if (!typeError) {
      newErrors.type = 'Выберите хотя бы 1 тип питания';
  }
  if (Object.keys(newErrors).length > 0) {
    setError(prevError => ({ ...prevError, ...newErrors }));
  }
  }  

  //Начальные значения при редактировании рецепта
  React.useEffect(()=> { 
    if(editCard && !isLoading) {    
      //setIngredientsData(editCard.ingredients) 
      setКitchenware(editCard.kitchenware.map(k => k._id))
      setTools(editCard.tools.map(k => k._id)) 
      setType(editCard.dietTypes) 
      setDescription(editCard.description) 
      setValues({
        name: editCard.name,
        category: editCard.category,
        servings: editCard.servings,
        complexity: editCard.complexity,
        feast: editCard.feast,
        daily: editCard.daily, 
        image: editCard.image,
        source: !editCard.source ? '' : editCard.source.url,
        advice: editCard.advice ? editCard.advice : '',
        metaDesc: editCard.metaDesc || editCard.name, 
        status: editCard.status
      })
    } 
  }, [editCard, isLoading])

   const handleEditSubmit = async (e) => {
    e.preventDefault();
    if(formError) {
      FormError();
    } else {
      const data = dataEditRecipe();
      try {
        // Отправка действия и ожидание выполнения
       // await dispatch(editRecipe({ data, id: editCard._id })).unwrap();
        // Если обновление прошло успешно, можно закрыть модал
       // props.onClose();
       // Отправляем на сервер
      saveRecipe({ data, id: editCard._id }, {
      onSuccess: (savedRecipe) => {
        console.log('✅ Рецепт сохранен:', savedRecipe);
        
        // Закрываем модалку
        props.onClose?.();
        
        // Вызываем колбэк успеха
      props.onSuccess?.(savedRecipe);
      },
      onError: (error) => {
        console.error('❌ Ошибка:', error);
        alert('Ошибка сохранения рецепта');
      }
    });
      } catch (error) {
        localStorage.setItem(
          "saves",
          JSON.stringify(data)
        )
      }
  }
};
 
  const handleSubmit  = async (e) => {
    e.preventDefault();
      if(formError) {
          FormError();
      } else {
        const data = dataRecipe() 
          try {
            saveRecipe({data}, {
              onSuccess: (savedRecipe) => {
                console.log('✅ Рецепт сохранен:', savedRecipe);
                // Закрываем модалку
                props.onClose?.();
                // Вызываем колбэк успеха
                props.onSuccess?.(savedRecipe);
              },
              onError: (error) => {
                console.error('❌ Ошибка:', error);
                alert('Ошибка сохранения рецепта');
              }
             })
             } catch (error) {
                localStorage.setItem(
                "saves",
                 JSON.stringify(data)
                )
          }
      }
  };

  /*React.useEffect(() => {
    if (statusRecipe === 'rejected' && errorRecipe) {
      console.log(statusRecipe,errorRecipe , recipeErrors) 
        setShowModal(true);
        setIconVisual(false);
        setTextsucces(recipeErrors[errorRecipe] || "Неизвестная ошибка, попробуйте позже, рецепт сохранен в черновиках");
       
    }
  },[statusRecipe, errorRecipe]);*/


  
 
  const handleIngredientsChange = (newIngredient) => { 
  // Добавляем новый ингредиент в массив
  console.log('delete', newIngredient)
  setRecipeData(prev => ({
    ...prev,
    ingredients: newIngredient
  }));
};

   console.log(recipeData)
 

  //формирование объекта для добавления на сервер данных
  function dataRecipe() {
    const newArr ={
      name: values.name,
        nameRu: values.name,
        feast: values.feast,
        daily: values.daily, 
        dietTypes:  type,  
        kitchenware: kitchenware,
        tools: tools ,
        complexity: values.complexity,
        ingredients:  recipeData.ingredients,
        servings:  values.servings, 
        image:  values.image,
        category: values.category, 
        advice:  values.advice, 
        source: values.source, 
        description: description,  
        status: values.status === 'private' ? 'private' : 'review',
        times:  timeForServer,
        time: Object.values(timeForServer).reduce((sum, t) => sum + t, 0)
    }  
    return newArr
  }
  
 
    //формирование объекта для редактирования рецепта
    function dataEditRecipe() {
      const newArr ={
        name: values.name,
        nameRu: values.name,
        feast: values.feast,
        daily: values.daily, 
        dietTypes:  type,  
        kitchenware: kitchenware,
        tools: tools ,
        complexity: values.complexity,
        ingredients:  recipeData.ingredients,
        servings:  values.servings, 
        image:  values.image,
        category: values.category, 
        advice:  values.advice, 
        source: values.source, 
        description: description,  
        status: values.status,
        times:  timeForServer,
        time: Object.values(timeForServer).reduce((sum, t) => sum + t, 0)
      } 
      return newArr
    }
    const handleStatusChange = (event) => {
     setValues((prevData) => ({
      ...prevData,
      status: event.target.value
    })); 
  };

  //Расчет калорий и протеинов для рецепта по списку добавленных ингредиентов с учетом потерь после обработки  
  /*let result = recipeData.ingredients.reduce((acc, v) => {
    const ingredient = ingredients.find(f => f._id === v._id); 
    if (!ingredient) {
        return acc;
    }
    //Поиск выбранной меры
    const measureRatio = ingredient.measure.find(i => i.nameRu === v.choisMeasure);
    if (!measureRatio) {
        return acc;
    } 
    const totalWeights = measureRatio.ratio * v.weight;  //Пересчет количества ингредиента в граммах
    const { protein, fats, carb, calories } = ingredient.calories; // Достали кбжу ингредиента на 100г
    const {purified, cooking, frying } = ingredient // Достали потери продуктов в зависимости от обработки
    const processType = v.note || 'none'; 
    const rateLooses =  processType === 'cooking' ? (1-cooking/100) :  processType === 'frying' ? (1-frying/100) : 1 // Процент потерь
    const lossesWeight = totalWeights*(1- purified / 100) *rateLooses 
    acc.totalMeasure += totalWeights; // Общий вес без учета потерь
    acc.protein += (protein * totalWeights) / 100; //КБЖУ всего блюда на все порции
    acc.fats += (fats * totalWeights) / 100;
    acc.carb += (carb * totalWeights) / 100;
    acc.calories += (calories * totalWeights) / 100;
    acc.totalWeight += lossesWeight  // Общий вес всего рецепта на все порции с учетом потерь обработки
    return acc;
  }, { protein: 0, fats: 0, carb: 0, calories: 0, totalMeasure: 0, totalWeight: 0 });*/

  
// Изменение количества порций вверх
const handleIncrease = () => {
  setValues((prevData) => ({
    ...prevData,
    servings: prevData.servings +1
  })); 
};

  // Изменение количества порций вниз
  const handleDecrease = () => {
    setValues((prevData) => ({
      ...prevData,
      servings: Math.max(prevData.servings - 1, 1) // Уменьшаем сервировки, но не ниже 1
    })); 
  };
 
   ///////////////////////////////////////ОБРАБОТКА ТИПОВ ПИТАНИЯ, ОБОРУДОВАНИЯ И ИНСТРУМЕНТОВ////////////////////////////////////////////////////
 
  const handleTypeClick = (item) => {  
    setType(prevSelected => {
      // Проверяем, есть ли уже этот тип в выбранных
      const typeIndex = prevSelected.indexOf(item._id);
      
      if (typeIndex === -1) {
        // Добавляем новый тип
        return [...prevSelected, item._id];
      } else {
        // Удаляем тип
        return prevSelected.filter(id => id !== item._id);
      }
    });
  };
 
  const handleAppliancesClick = (item) => { 
    setКitchenware(prevSelected => {
      // Проверяем, есть ли уже этот тип в выбранных
      const typeIndex = prevSelected.indexOf(item._id);
      
      if (typeIndex === -1) {
        // Добавляем новый тип
        return [...prevSelected, item._id];
      } else {
        // Удаляем тип
        return prevSelected.filter(id => id !== item._id);
      }
    });
  };

  function handleToolsClick(item) {  
    setTools(prevSelected => {
      // Проверяем, есть ли уже этот тип в выбранных
      const typeIndex = prevSelected.indexOf(item._id);
      
      if (typeIndex === -1) {
        // Добавляем новый тип
        return [...prevSelected, item._id];
      } else {
        // Удаляем тип
        return prevSelected.filter(id => id !== item._id);
      }
    });
  }

  //////////////////////////////////////ОБРАБОТКА ФОТОГРАФИЙ////////////////////////////////////////////////////
  const handleTextChange = (index, e) => {
      const newText = e.target.value; 
      validate(`step${index+1}`, newText, index)
      setDescription((prev) => {
        const updated = [...prev]; 
        updated[index] = {
          ...updated[index],
          text: newText
      };

      return updated;
      });
  };
  
  const handleFileChange = (index, e) => {
    const file = e.target.files[0];
    if (file) { 
      const reader = new FileReader();
      reader.onloadend = () => {
        setDescription((prev) => {
          // Создаем полностью новый массив с обновленным объектом
          return prev.map((item, i) => {
            if (i === index) {
              // Создаем новый объект для нужного элемента
              return {
                ...item,
                image: reader.result
              };
            }
            return item;
          });
        });
      };
      reader.readAsDataURL(file);
    }
  };


  //Удаление фотографий для шагов
  const handleDeleteImg = (index, e) => { 
    setDescription((prev) => {
          const updated = [...prev];
          updated[index].image = ''; // Используем индекс для обновления конкретного шага
          return updated;
        });
      
  };

  //Удаление фотографий для блюда
  const handleDeleteImages = (image) => { 
    const newFile = values.image.filter(c => c !== image) 
    setValues(prevValues => ({
      ...prevValues,
      image: newFile, // Объединяем предыдущие изображения с новыми
    }));

  };
 
  const handleAddFiles = async (e) => {
    const imgArr = [];
    const filePromises = []; // Массив для хранения промисов
  
    try {
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        const reader = new FileReader();
        
        const filePromise = new Promise((resolve, reject) => {
          reader.onloadend = () => {
            imgArr.push(reader.result); // Добавляем изображение в формате base64 в массив
            resolve();
          };
          reader.onerror = (error) => {
            reject(error);
          };
          reader.readAsDataURL(file); // Преобразуем файл в base64
        });
  
        filePromises.push(filePromise); // Добавляем промис в массив
      }
  
      // Ждем, пока все файлы будут обработаны
      await Promise.all(filePromises);
  
      // Теперь обновим values.images, добавив новыми изображениями в формате base64
      setValues(prevValues => ({
        ...prevValues,
        image: [...prevValues.image, ...imgArr], // Объединяем предыдущие изображения с новыми
      }));
      if(imgArr.length > 0 ) {
        setImageError('')
      }
     
    } catch (err) {
      console.log(err);
    }
  }
 
  //Добавление шага с описанием
  const handleAddStep = () => {
    setDescription((prev) => [
      ...prev,
      { step: prev.length + 1, image: '', text: '' }
    ]);
  }; 
  

 
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenCat, setIsOpenCat] = React.useState(false);
 
  function handleFocus() {
    setIsOpen(!isOpen)
  } 
 

    const handleAcceptRecipe = () =>  {
      dispatch(acceptRecipeUser(editCard._id ))
    }

  return (
    <form onSubmit={editCard === undefined ? handleSubmit : handleEditSubmit} className='form flexColCenter'>
      <h2 className='font32EB'>{!editCard ? 'ДОБАВИТЬ РЕЦЕПТ' : 'Редактировать рецепт'}</h2>
      <div className='form__content'>
        <fieldset className='form__fieldset fieldset__title'> 
        <div className='form__fieldset_block'>
          <legend className='font20EB color'>Название блюда </legend>
          <label className='form__label form__label_err'>
          <InputText 
            type='text' 
            types='name' 
            title=''
            value={values.name}
            onChange={handleChange}
            placeholder= 'Название блюда'
            name='name' 
            id='name' 
            error={nameError}
          /> 
          </label> 
        </div> 
          {isSuccessLib && 
        <div className='form__fieldset_block'>
          <legend className='font20EB color'>Категория блюда </legend>
         {/* <label className='form__label form__label_err'> */ } 
            <label className={`font20EB color form__label_complex ${isOpenCat ? 'form__label_complex_open': 'form__label_complex_close'}`} > 
            <Select  
              onChange={handleChange}  
              value={values.category}
              lib={lib.dishTypes}
              actions='Выберите категорию блюда'
              name='category'
              id='category'
              title=''
              error={сategoryError}
              />
             {сategoryError && <span className="form__text_error font14Norm">{сategoryError}</span>} 
          </label>
          </div> 
          } 
          <label className='form__label_capacity font20Norm colorGrey'> 
            <span className="form__span_cooking"> </span>
            Количество порций
            <InputCounter handleIncrease={handleIncrease} values={values.servings} handleDecrease={handleDecrease} name='servings' id='servings'/>
          </label>
          <div className='fieldset__course'> 
            <InputCheckbox title='Праздничное блюдо' onChange={handleChange} checked={values.feast} value={values.feast} name='feast'  id='feast'/>
            <InputCheckbox title='Повседневное блюдо' onChange={handleChange} checked={values.daily} value={values.daily} name='daily'   id='daily'/> 
        </div> 
        <div className='form__fieldset_block form__label_err'>
          <div className='fieldset__course'>  
            <span className="form__span_complex"> </span> 
            <label className={`font20EB color form__label_complex `}  onClick={handleFocus}> 
            <div className={`form__input_select_block ${isOpen ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocus}>
         
              <Select  
              onChange={handleChange}  
              value={values.complexity} 
              actions='Сложность блюда'
              name='complexity'
              id='complexity' 
              lib={complex}
              error={complexError}
              />  
             </div> 
          </label> 
          <Tooltip content={hint.complex} />
          </div> 
          {complexError && <span className="form__text_error font14Norm">{complexError}</span>}
          </div> 
      
        </fieldset> 
                                           {/*Блок со временем приготовления */} 
        <fieldset className='form__fieldset fieldset__time'>
      <legend className='form__legend font20EB color'>
        Время приготовления
        <Tooltip content={hint.times} />
      </legend>
      
      {lib?.timeStages.map((stage, index) => (
        <TimeInput
          key={stage.timeKey}
          timeStage={stage}
          recipeTimes={recipeTimes}
          onTimeChange={handleTimeChange}
          onUnitChange={handleUnitChange}
          errors={error}
          index={index}
        />
      ))}
    </fieldset>
      </div>
                                             {/*Блок с добавлением ингредиентов */} 
    
    <div className='flexColCenter'>
       <IngredientsForm
        ingredientsLib={ingredients}
        initialData={recipeData.ingredients}
        onIngredientsChange={handleIngredientsChange}
        error={error}
      />
    </div>
                                     {/*Блок с добавлением тИпа питания, инструментов и оборудования */} 
      <div className="flexColCenter">
        <fieldset className='fieldset__type'>
        <div className='form__block_legend'>
          <legend className='form__legend font20EB color'>Тип питания <Tooltip content={hint.type} /> </legend>
          {error.type && <span className="form__text_error font14Norm">{error.type}</span>}
          </div>
          <div className='form__block_type'>
          {   /*statusLib === 'resolved' &&
            type.map((item, index)=> (
              <button type='button' key={index} onClick={()=>handleTypeClick(item)} className={`buttonGrey font20Norm ${item.boolean ? 'fon-colors': ''}`} >{item.nameRu}</button>
            ))  */
           isSuccessLib &&
            lib.dietTypes.map((item) => (
              <button
                type='button'
                key={item._id}
                onClick={() => handleTypeClick(item)}
                className={`buttonGrey font20Norm ${
                  type.includes(item._id) ? 'fon-colors' : ''
                }`}
              >
                {item.nameRu}
              </button>
            ))}
          
          </div>
        </fieldset>
        <fieldset className='fieldset__type'>
        <div className='form__block_legend'>
          <legend className='form__legend font20EB color'>Оборудование <Tooltip content={hint.appliances} /></legend>
          </div>
          <div className='form__block_type'>
         {/* statusLib === 'resolved' &&
            kitchenware.map((item, index)=> (
              <button type='button' key={index} onClick={()=>handleAppliancesClick(item)} className={`buttonGrey font20Norm ${item.boolean ? 'fon-colors': ''}`} >{item.nameRu}</button>
            )) 
         */ }
          {
            isSuccessLib &&
            lib.kitchenware.map((item) => (
              <button
                type='button'
                key={item._id}
                onClick={() => handleAppliancesClick(item)}
                className={`buttonGrey font20Norm ${
                  kitchenware.includes(item._id) ? 'fon-colors' : ''
                }`}
              >
                {item.nameRu}
              </button>
            ))
          }
           </div>
        </fieldset>
        <fieldset className='fieldset__type'>
        <div className='form__block_legend'>
          <legend className='form__legend font20EB color'>Инструменты <Tooltip content={hint.tools} /></legend>
          </div>
          <div className='form__block_type'>
          {isSuccessLib &&
           lib.tools.map((item, index)=> (
            <button
                type='button'
                key={item._id}
                onClick={() => handleToolsClick(item)}
                className={`buttonGrey font20Norm ${
                  tools.includes(item._id) ? 'fon-colors' : ''
                }`}
              >
                {item.nameRu}
              </button>
              )) 
          }
             </div>
        </fieldset>
      </div>

                                        {/*Блок с добавлением описания */} 
      <div className="flexColCenter form__step_container">
      <legend className='form__legend form__legend_step font20EB color'>Пошаговая инструкция</legend>
      <p className='form__step_text colorGrey font20EB'>Подробная иструкция поможет правильно приготовить ваш рецепт. По желанию загрузите фото каждого шага.</p>
      { description.map((item, index) =>   
        <StepRecipe 
          key={index} 
          item={index+1}
          step={item.step}
          name={`step${index+1}`}
          description={item} 
          onChange={(e) => handleTextChange(index, e)} // Передаем индекс
          handleFileChange={(e) => handleFileChange(index, e)} // Передаем индекс
          handleAddStep={handleAddStep}
          value={item.text}
          handleDeleteImg={(e) => handleDeleteImg(index, e)}
          error={error}
        />
        )}
         <button type='button' className={`buttonGreen form__button_step `}  onClick={handleAddStep}>Добавить ещё шаг</button>
   
      </div>
                                         {/*Блок с добавлением фото блюда и ссылки */} 
        <div className="flexColCenter">
      <fieldset className='flexRowSB'>   
      <div className='form__block_legend'>
      <button type='button' className=' buttonGreen '>
          <input 
            type="file"
            id="addImage"
             name="addImage" 
             onChange={handleAddFiles} 
             multiple="multiple"
            className="form__input_file_all"
          />  
          <span>   Загрузить фото блюда</span>
        </button>  
        {imageError && <span  className="form__text_error font14Norm">{imageError}</span>}
        </div>
      <div>
      <p className="form__title font20EB" >Введите ссылку на рецепт, если автор не вы</p>
        <input 
          type='url' 
          types='author'
          value={values.source || ''}
          onChange={handleChange}
          placeholder= 'Ссылка на рецепт'
          name='source' 
          id='source'  
          className='form__input'
        />
       </div>
      </fieldset>
      <div className='form__image_list flexRowStart'>
        {values.image.length> 0 &&
        values.image.map((i, index) => (
          <div  key={index} className='form__image_block' >
            <img src={i} className='form__images' alt={props.image} />
            <p className="form__step_img_delete gg-delete m-size" onClick={()=> handleDeleteImages(i)}></p>
          </div> 
        ))
        }
      </div>
        </div>
      
      {!editCard && 
        <div className='fieldset__status'>
          <InputCheckbox title='Сделать рецепт приватным' onChange={handleChange} checked={values.status} value={values.status} name='status'  id='status'/>
        </div>
      }
      {currentUser.supervisor && 
              <> 
              <fieldset className='flexColStart'>
              <legend className='form__legend_period font20EB color'>Принять рецепт?  </legend> 
                  <InputRadio
                    options={options}
                    selectedValue={values.status}
                    onChange={handleStatusChange}
                    name='status'
                  />
                  <button type="button" onClick={handleAcceptRecipe} disabled={values.status !== 'active'} className={`buttonGreen buttonGreen__signin ${values.status !== 'active' ? ('buttonDisabled') : 'section__link'}`} >Приянть и начислить баллы</button>
              </fieldset>
              
              </>
            }
      <button type="submit" disabled={submitDisabled}  className={`buttonGreen buttonGreen__signin color ${submitDisabled ? ('buttonDisabled') : 'section__link'}`} >
      {statusRecipe === 'loading' ?  <Loader type= 'signin' /> : buttonTitle} 
      </button>
      {submitDisabled && <span className="form__text_error font14Norm">Не все обязательные поля заполнены</span>}
     
      
    </form>
  );
};
 
 
export function filtrSearchArr(arr, keyword) {
  const keywordSearch = keyword.toLowerCase();
  return arr.filter(item => item.name.toLowerCase().includes(keywordSearch));
}


const StepRecipe = (props) => {
  const image = props.description.image 
  const disabled = props.value ===''
  const lengthDesc = props.description.text.length 
  const errorValue = props.error[props.name];  
  
  return (
    <article className='form__step_item'>
      <p className='font20EB colorGrey'>ШАГ №{props.step}</p>
      <label className='form__label'> 
      <div className='file-input-wrapper'> 
  {image === '' ? 
    <>
      <input 
        type="file"
        id="addImage"
        name="addImage" 
        onChange={props.handleFileChange} 
        multiple
        className="form__input_file"
      /> 
      <span className='form__file_visible forn14Norm colorGrey'></span>
    </>
 : <ImageFields image ={image} onClick={props.handleDeleteImg } />
    
  } 
      </div>
        <textarea  
          rows="4"
          cols='50' 
          min="10" 
          max="1000" 
          id={`step${props.step}`}
          name={`step${props.step}`}
          value={props.value}
          onChange={props.onChange}
          placeholder='Введите шаг приготовления' 
          className={`form__input_text-area font20Norm colorGrey ${errorValue ? 'form__input_error' : ''}`} 
        />  
       <span className='form__step_count forn14Norm colorGrey '>{lengthDesc}/1000</span>
        </label>
         <div className='error__block'> {errorValue && <span className="form__text_error font14Norm">{errorValue}</span>}</div>
        </article>
  )
}



  const ImageFields = (props) => {   
    function handleClick() {
      props.onClick(props.image)
    }
  
    return (
      <div>
      <img src={props.image} className={`${props.type === 'image__list' ? 'form__images': 'form__step_img'}`} alt={props.image} />
      <p className="form__step_img_delete gg-delete m-size" onClick={handleClick}></p>
      </div>
    )
  };

